import React, { ChangeEvent, Component, FocusEvent, HTMLAttributes, KeyboardEvent, MouseEvent, ReactNode } from 'react';
import { InputText } from 'primereact/inputtext';

class TransformableInputAreaComponent extends Component<Props, State> {
  public state: State = new State();

  public render(): ReactNode {
    const { isText, text } = this.state;
    const { children, className, disabled, ...rest } = this.props;
    return (
      <div className={`${className} transformable-input-area`} {...rest}>
        {isText ? (
          <span onClick={this.toggle}>{children}</span>
        ) : (
          <InputText
            style={{ borderRadius: 0, fontSize: 12 }}
            value={text}
            disabled={disabled}
            onChange={this.onChangeText}
            className={`${className} text-2xs !border-transparent active:rounded-none !bg-transparent`}
            onBlur={this.toggle}
            onKeyDown={this.onKeyDown}
            autoFocus
          />
        )}
      </div>
    );
  }

  public componentDidMount(): void {
    const { value } = this.props;
    this.setState({ text: value });
  }

  private toggle = (e: MouseEvent | FocusEvent | KeyboardEvent): void => {
    e.stopPropagation();
    e.preventDefault();
    const { isText, text } = this.state;
    const { onClose, value, disabled } = this.props;
    if (disabled) return;
    if (!isText) {
      this.props.onVisible?.();
      onClose(text);
      this.setState({ isText: !isText });
    } else {
      this.setState({ isText: !isText, text: value });
    }
  };

  private onKeyDown = (e: KeyboardEvent): void => {
    if (e.key == 'Enter') this.toggle(e);
  };

  private onChangeText = (e: ChangeEvent<HTMLInputElement>): void => {
    this.setState({ text: e.target.value });
  };
}

class State {
  isText: boolean = true;
  text: string = '';
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  inputProperties?: HTMLAttributes<HTMLInputElement>;
  onClose: (value: string) => void;
  onVisible?: () => void;
  value: string;
  disabled?: boolean;
}

export default TransformableInputAreaComponent;
